import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Table, Image, Button, Icon } from "semantic-ui-react";
import { toast } from "react-toastify";
import _ from "lodash";
import cx from "classnames";

import InfiniteScroll from "components/ui/InfiniteScroll";

import styles from "./domains.module.scss";
import {
  deleteCleverstoryDomain,
  fetchCleverstoryDomains,
  updateCleverstoryDomain,
  updateCleverstoryDomainAsPrimary,
} from "actions/cleverstory";
import CreateDomain from "./CreateDomain";
import { useParams } from "react-router-dom";
import ConfirmModal from "components/ui/ConfirmModal";

export default function Domains({ account, setLoading }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const [initialRender, setInitialRender] = useState(true);
  const [updateDomain, setUpdateDomain] = useState(null);
  const [updateDomainOpen, setUpdateDomainOpen] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [deleteDomainId, setDeleteDomainId] = useState(null);

  const domains = useSelector((state) =>
    _.get(state, "cleverstoryDomains.items.records", [])
  );
  const loading = useSelector((state) =>
    _.get(state, "cleverstoryDomains.loading")
  );

  let { id } = useParams();
  let workspaceId = id;

  useEffect(() => {
    setLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (!loading && account) {
      dispatch(
        fetchCleverstoryDomains({
          account: account.id.toString(),
          workspace: workspaceId,
        })
      );
    }
  }, []);

  setTimeout(
    function () {
      setInitialRender(false);
    },
    [3000]
  );

  const handleClick = (item) => {
    history.push({
      pathname: `/paperflite/accounts/${account.id}/cleverstory/${item.id}`,
      state: { accountId: account.id, workspaceId: item.id },
    });
  };

  const handleEdit = (domain) => {
    setUpdateDomain(domain);
    setUpdateDomainOpen(true);
  };

  const handleEditPrimary = (domain) => {
    dispatch(
      updateCleverstoryDomainAsPrimary({
        workspaceId: workspaceId,
        domainId: domain.id,
        data: {
          cloudfrontDistribution: domain.cloudfrontDistribution,
          url: domain.url,
          primary: true
        },
      })
    );
  };

  const handleDelete = (domainId) => {
    setDeleteDomainId(domainId);
    setShowDeleteConfirmation(true);
  };

  const onModalConfirm = () => {
    dispatch(
      deleteCleverstoryDomain({
        workspaceId: workspaceId,
        domainId: deleteDomainId,
      })
    );
    setShowDeleteConfirmation(false);
    toast.success("Domain deleted successfully");
  };

  const onModalCancel = () => {
    setShowDeleteConfirmation(false);
  };

  return (
    <>
      <Table singleLine className={cx(styles.table)}>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={3} className={cx(styles.header)}>
              CLOUDFRONT DISTRIBUTION
            </Table.HeaderCell>
            <Table.HeaderCell width={3} className={cx(styles.header)}>
              URL
            </Table.HeaderCell>
            <Table.HeaderCell width={3} className={cx(styles.header)}>
              PRIMARY
            </Table.HeaderCell>
            <Table.HeaderCell className={cx(styles.header)}></Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body className={cx(styles.body)}>
          {!loading && domains.length === 0 && (
            <>
              <Table.Row>
                <Table.Cell colSpan="5" className={cx(styles.cell)}>
                  <div className={cx(styles.noData)}>No Domains</div>
                </Table.Cell>
              </Table.Row>
            </>
          )}

          {loading && domains.length === 0 && (
            <>
              <Table.Row>
                <Table.Cell colSpan="5" className={cx(styles.cell)}>
                  <div className={cx(styles.noData)}>
                    Loading
                    <Icon name="sync" loading className={cx(styles.icon)} />
                  </div>
                </Table.Cell>
              </Table.Row>
            </>
          )}

          {domains.length !== 0 && (
            <>
              {domains.map((item, idx) => (
                <>
                  <Table.Row key={idx}>
                    <Table.Cell width={2} className={cx(styles.cell)}>
                      <div
                        className={cx(styles.text, styles.pointer)}
                        onClick={() => handleClick(item)}
                      >
                        {item.cloudfrontDistribution}
                      </div>
                    </Table.Cell>
                    <Table.Cell width={2} className={cx(styles.cell)}>
                      <div className={cx(styles.text)}>{item.url}</div>
                    </Table.Cell>
                    <Table.Cell width={1} className={cx(styles.cell)}>
                      <div className={cx(styles.text, styles.primary)}>
                        {item.primary ? "TRUE" : "FALSE"}
                        {!item.primary && (
                          <div
                            className={styles.actionIcons}
                            onClick={() => handleEditPrimary(item)}
                          >
                            <Icon name="edit outline" />
                            <span>Make Primary</span>
                          </div>
                        )}
                      </div>
                    </Table.Cell>

                    <Table.Cell width={1} className={cx(styles.cell)}>
                      <div className={styles.actions}>
                        <div
                          className={styles.actionIcons}
                          onClick={() => handleEdit(item)}
                        >
                          <Icon name="edit outline" />
                          <span>Edit</span>
                        </div>
                        {!item.primary &&
                          <div
                            className={cx(styles.actionIcons, styles.addBorder)} 
                            onClick={() => handleDelete(item.id)}
                          >
                            <Icon name="trash alternate outline" />
                            <span>Delete</span>
                          </div>
                        }
                      </div>
                    </Table.Cell>
                  </Table.Row>
                </>
              ))}
            </>
          )}
        </Table.Body>
      </Table>
      <CreateDomain
        account={account}
        open={updateDomainOpen}
        setOpen={setUpdateDomainOpen}
        domain={updateDomain}
      />
      <ConfirmModal
        open={showDeleteConfirmation}
        setOpen={setShowDeleteConfirmation}
        onSave={onModalConfirm}
        onCancel={onModalCancel}
        content={"Are you sure want to delete this domain?"}
      />
    </>
  );
}
